import React, { FC } from 'react';

import { ResourcesLoader } from 'omni-package-react-core';
import Grid from './Grid';
import NewsResource from '../../components/NewsResource';

export interface AllNewsPageProps { }

const AllNewsPage: FC<AllNewsPageProps> = () => (
  <ResourcesLoader>
    <ResourcesLoader.Resources>
      <NewsResource autoRequest autoRequestIfEmpty requestOnLanguageChange />
    </ResourcesLoader.Resources>
    <ResourcesLoader.Content>
      <Grid />
    </ResourcesLoader.Content>
  </ResourcesLoader>
);

export default (AllNewsPage);
